import { Modal } from './parts';
import { RoleIcon } from './Icon';
import type { PublicPlayer, Role } from '../game/types';
import { characterAbilityKey, characterName, roleColor } from '../game/cardMeta';
import { roleArt } from '../game/art';
import { useT } from '../i18n';

/** Full description of the player's own role + character, opened from the table badge. */
export function RolePanel({
  role,
  me,
  onClose,
}: {
  role: Role;
  me: PublicPlayer | null;
  onClose: () => void;
}) {
  const t = useT();
  const color = roleColor[role];
  const character = me?.characterId ? characterName[me.characterId] : null;
  const abilityKey = me?.characterId ? characterAbilityKey[me.characterId] : null;
  const ability = abilityKey ? t.ability[abilityKey] : null;

  return (
    <Modal onClose={onClose}>
      <div className="col center" style={{ gap: 12 }}>
        <div className="eyebrow">{t.rolePanel.your}</div>
        <div
          className="role-panel-art"
          style={{ backgroundImage: `url(${roleArt(role)})`, ['--role-color' as string]: color }}
        />
        <div style={{ color }}><RoleIcon role={role} size={42} /></div>
        <div style={{ fontSize: 28, fontWeight: 900, letterSpacing: '0.1em', color }}>
          {t.role.name[role]}
        </div>
        <div className="mono-dim" style={{ lineHeight: 1.5, textAlign: 'center' }}>
          {t.role.desc[role]}
        </div>

        {character && (
          <div
            className="panel col"
            style={{ gap: 6, width: '100%', borderColor: 'var(--violet)', marginTop: 6 }}
          >
            <div className="row between">
              <span className="eyebrow" style={{ color: 'var(--violet)' }}>{t.rolePanel.character}</span>
              <span style={{ fontWeight: 800, color: 'var(--violet)' }}>{character}</span>
            </div>
            {ability && (
              <span className="mono-dim" style={{ fontSize: 12, lineHeight: 1.4 }}>{ability}</span>
            )}
          </div>
        )}

        <button className="btn block cyan" style={{ marginTop: 4 }} onClick={onClose}>
          {t.rolePanel.back}
        </button>
      </div>
    </Modal>
  );
}
